'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Option = require('./Option');

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_Component) {
    (0, _inherits3.default)(Select, _Component);

    function Select(props) {
        (0, _classCallCheck3.default)(this, Select);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));

        _react2.default.Children.forEach(props.children, function (child) {
            if (child.type !== _Option2.default) {
                throw new Error('Every child of <Select> must be an <Option>. Received ' + child.type + '.');
            }
        });

        _this.state = { el: void 0 };

        _this.setRef = _this.setRef.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Select, [{
        key: 'setRef',
        value: function setRef(el) {
            if (el && !this.state.el) {
                this.setState({ el: el });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                type = _props.type,
                children = _props.children;


            return _react2.default.createElement(
                'select',
                {
                    ref: this.setRef,
                    type: type,
                    id: id
                },
                children
            );
        }
    }]);
    return Select;
}(_react.Component);

exports.default = Select;


Select.propTypes = {
    id: _propTypes2.default.string,
    type: _propTypes2.default.string,
    question: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired
};

Select.defaultProps = {
    type: 'text',
    id: void 0
};


//////////////////
// WEBPACK FOOTER
// ./~/react-conversation-form/dist/Select.js
// module id = 278
// module chunks = 0